import { Component, OnInit } from '@angular/core';
import { PageComponent, PageService, Page, AppConfig } from '@tytapp/common';
import { environment } from 'environment';

@Page('registration-benefits')
@Component({
    selector: 'tyt-free-account-benefits',
    templateUrl: './free-account-benefits.component.html',
    styleUrls: ['./free-account-benefits.component.scss']
})
export class FreeAccountBenefitsComponent extends PageComponent implements OnInit {
    enableYouTubeLogin = false;

    constructor(
        pageService: PageService,
        private appConfig: AppConfig
    ) {
        super(pageService);
    }

    async init() {
        this.enableYouTubeLogin = await this.appConfig.featureEnabled('apps.web.enable_youtube_login');
    }

    oauthUrlFor(provider: string) {
        return `${environment.urls.platform}/sign-in-with/${provider}`;
    }
}
